<template>
  <b-modal
    ref="modal-walkin"
    :size="modalSize"
    centered
    title="Actualizar Sucursal"
    style="width: 70%"
    hide-footer
    v-model="showModal"
    @hidden="$emit('closeModal')"
  >
    <VueElementLoading spinner="bar-fade-scale" color="var(--primary)" />
    <ModalBody />
    <ModalFooter />
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { BButton, BRow, BCol } from 'bootstrap-vue'
import ModalFooter from './modal-footer'
import ModalBody from './modal-body'
import VueElementLoading from 'vue-element-loading'

export default {
	components: {
		BButton,
		BRow,
		BCol,
		VueElementLoading,
		ModalFooter,
		ModalBody,
	},
	computed: {
		showModal: {
			get() {
				return this.$store.state.locations.showModal
			},
			set() {},
		},
		...mapState('locations', ['modalSize'])
	},
}
</script>
